import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import { WithSitecoreContextProps } from '../../../types/types';
import { TSocialMediaBarProps } from '../../@shared/socialMediaBar/types/socialMediaBar.types';

export enum Weekdays {
  monday = 'monday',
  tuesday = 'tuesday',
  wednesday = 'wednesday',
  thursday = 'thursday',
  friday = 'friday',
  saturday = 'saturday',
  sunday = 'sunday',
}

export type TBusinessHours = {
  [key: string]: string;
};

export type TBusinessHoursMappedValue = {
  [key: string]: string[];
};

export type TBusinessHoursModelValue = {
  hours: TBusinessHoursMappedValue;
  hasMorningHours: boolean;
  hasEveningHours: boolean;
};

export type TAwardProps = Partial<{
  brand: string;
  designationName: string;
  imageUrl: string;
  landingImageUrl: string;
}>;

export type TDealershipAttributes = Partial<{
  website: string;
  logoImage: string;
  photoImage: string;
  message: string;
  promo: string;
  awardDesignations: TAwardProps[];
  sundayAMStart: string;
  sundayAMEnd: string;
  sundayPMStart: string;
  sundayPMEnd: string;
  mondayAMStart: string;
  mondayAMEnd: string;
  mondayPMStart: string;
  mondayPMEnd: string;
  tuesdayAMStart: string;
  tuesdayAMEnd: string;
  tuesdayPMStart: string;
  tuesdayPMEnd: string;
  wednesdayAMStart: string;
  wednesdayAMEnd: string;
  wednesdayPMStart: string;
  wednesdayPMEnd: string;
  thursdayAMStart: string;
  thursdayAMEnd: string;
  thursdayPMStart: string;
  thursdayPMEnd: string;
  fridayAMStart: string;
  fridayAMEnd: string;
  fridayPMStart: string;
  fridayPMEnd: string;
  saturdayAMStart: string;
  saturdayAMEnd: string;
  saturdayPMStart: string;
  saturdayPMEnd: string;
}>;

export type TDealerDetailProps = Partial<{
  dealerName: string;
  shippingAddress: string;
  shippingAddress1: string;
  shippingCity: string;
  shippingZip: string;
  shippingPhone: string;
  dealerWebsite: string;
  shippingFax: string;
  dealerEmail: string;
  latitude: string;
  longitude: string;
  BusinessHour: TBusinessHours;
  dealershipAttributes: TDealershipAttributes;
  shippingStateProv:string;
}>;

export type TDealerLocatorDetailFilterDetails = Partial<{
  Title: string;
  Code: string;
  Icon: string;
}>;

export type TDealerLocatorDetailFilters = Partial<{
  Equipments: Array<TDealerLocatorDetailFilterDetails>;
  Services: Array<TDealerLocatorDetailFilterDetails>;
}>;

export type TDealerLocatorDetailItemData = Partial<{
  fields: {
    settings: {
      dealerLocatorGoogleMapsAPIKey: string;
    };
    filters: TDealerLocatorDetailFilters;
  };
}>;

export type TDealerLocatorDetailApiData = {
  dealerDetail: TDealerDetailProps;
};

export type TDealerLocatorPropsFields = {
  apiData: TDealerLocatorDetailApiData;
  itemData: TDealerLocatorDetailItemData;
  isComponentUnreleased?: boolean;
  socialMediaBar?: TSocialMediaBarProps;
};

export type TDealerLocatorDetailProps = WithSitecoreContextProps & {
  componentName?: string;
  fields: TDealerLocatorPropsFields;
  rendering?: ComponentRendering;
  params?: any;
};

export type TDealerContactsProps = {
  apiKey: string;
  latitude: string;
  longitude: string;
  addressDetails: TAddressDetails;
};

export type TAddressDetails = Partial<{
  fax: string;
  phone: string;
  email: string;
  website: string;
  address: string;
}>;

export type TBusinessHoursProps = {
  businessHours: TBusinessHoursModelValue;
  hasBusinessHours: boolean;
  certifications: TAwardProps[];
  hasCertifications: boolean;
};
